<template>
  <footer class="no-print">
    <div class="hidden-xs hidden-sm">
      Copyright &copy CognaLearn Pte Ltd 2015 ~
      <span id="year"></span> &nbsp;&nbsp;|&nbsp;&nbsp;<a
        href="https://www.intedashboard.com/terms-of-use/"
        target="_blank"
        class="pointer"
        aria-label="Terms of Use opens in a new tab."
        >Terms of Use</a
      >&nbsp;&nbsp;|&nbsp;&nbsp;<a
        href="https://www.intedashboard.com/privacy-policy/"
        target="_blank"
        class="pointer"
        aria-label="Privacy Policy opens in a new tab."
        >Privacy Policy</a
      >
    </div>

    <div class="hidden-md hidden-lg">
      <div>
        Copyright &copy CognaLearn Pte Ltd 2015 ~ <span id="year"></span>
      </div>
      <div>
        <a
          href="https://www.intedashboard.com/terms-of-use/"
          target="_blank"
          class="pointer"
          aria-label="Terms of Use opens in a new tab."
          >Terms of Use</a
        >&nbsp;&nbsp;|&nbsp;&nbsp;<a
          href="https://www.intedashboard.com/privacy-policy/"
          target="_blank"
          class="pointer"
          aria-label="Privacy Policy opens in a new tab."
          >Privacy Policy</a
        >
      </div>
    </div>

    <div class="clearfix"></div>
  </footer>
</template>
<script>
export default {
  mounted() {
    if (_.get(this.$route.params, "otp", false)) {
      $("footer").hide();
    }

    document.getElementById("year").innerHTML = moment().format("YYYY");
  },
  watch: {
    $route: {
      handler: function() {
        if (_.get(this.$route.params, "otp", false)) {
          $("footer").hide();
        } else {
          $("footer").show();
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
body.test footer {
  margin-left: 0px;
}
</style>
